import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
    selector: 'restore-form',
    templateUrl: './component.html'
})
export class RestoreFormComponent {
    @Input() public error: any;
    @Input() public showLoader: boolean;
    @Output() public onLogin = new EventEmitter<any>();
    @Output() public onClearError = new EventEmitter();
    private restoreForm: FormGroup;

    constructor(private fb: FormBuilder) { }

    public ngOnInit() {
        this.restoreForm = this.fb.group({
            email: null,
            password: null,
            passwordConfirmation: null,
            agree: false
        });

        this.restoreForm.valueChanges
            .filter(() => !!this.error)
            .forEach(() => {
                this.clearError();
            });
    }

    private clearError() {

    }
}


// WEBPACK FOOTER //
// ./src/app/public/restore/form/component.ts